// Dark Mode Toggle Functionality
class ThemeManager {
  constructor() {
    this.currentTheme = this.getStoredTheme() || 'light'; // Light as default
    this.init();
  }

  init() {
    // Set initial theme
    this.setTheme(this.currentTheme);

    // Listen for theme toggle button
    const toggleButton = document.getElementById('theme-toggle');
    if (toggleButton) {
      toggleButton.addEventListener('click', () => this.toggleTheme());
    }

    // Update toggle button state
    this.updateToggleButton();
  }

  getStoredTheme() {
    try {
      return localStorage.getItem('theme');
    } catch (e) {
      return null;
    }
  }

  setStoredTheme(theme) {
    try {
      localStorage.setItem('theme', theme);
    } catch (e) {
      console.error('Failed to save theme preference:', e);
    }
  }

  setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    this.currentTheme = theme;
    this.setStoredTheme(theme);
    this.updateToggleButton();
    this.updateBrowserChrome();

    // Dispatch theme change event
    document.dispatchEvent(new CustomEvent('themechange', { detail: { theme } }));
  }

  updateBrowserChrome() {
    const styles = getComputedStyle(document.documentElement);
    const bgColor = styles.getPropertyValue('--bg-primary').trim();
    if (bgColor) {
      document.documentElement.style.backgroundColor = bgColor;
      const metaThemeColor = document.querySelector('meta[name="theme-color"]');
      if (metaThemeColor) {
        metaThemeColor.setAttribute('content', bgColor);
      }
    }
  }

  toggleTheme() {
    const newTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
    this.setTheme(newTheme);
  }

  updateToggleButton() {
    const toggle = document.getElementById('theme-toggle');
    if (toggle) {
      const icon = toggle.querySelector('.theme-toggle-icon');
      if (icon) {
        // Update icon based on current theme
        if (this.currentTheme === 'dark') {
          // Show moon icon (dark mode is active)
          icon.innerHTML = `
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
            </svg>
          `;
        } else {
          // Show sun icon (light mode is active)
          icon.innerHTML = `
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
            </svg>
          `;
        }
      }
    }
  }
}

// Initialize theme manager when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.themeManager = new ThemeManager();

  // Create background animation elements
  createBackgroundAnimation();
});

// Create background animation
function createBackgroundAnimation() {
  if (document.querySelector('.bg-animation')) return;

  const bgContainer = document.createElement('div');
  bgContainer.className = 'bg-animation';
  bgContainer.style.boxShadow = 'none';

  // Gradient background
  const gradient = document.createElement('div');
  gradient.className = 'bg-gradient-animated';
  gradient.style.boxShadow = 'none';

  // Grid pattern
  const grid = document.createElement('div');
  grid.className = 'grid-pattern';
  grid.style.opacity = '0.03';

  // Floating particles
  for (let i = 1; i <= 6; i++) {
    const particle = document.createElement('div');
    particle.className = 'particle';
    particle.style.background = 'var(--accent-primary)';
    bgContainer.appendChild(particle);
  }

  bgContainer.appendChild(gradient);
  bgContainer.appendChild(grid);
  document.body.appendChild(bgContainer);
  
  // Explicitly remove any blue vignette
  const style = document.createElement('style');
  style.textContent = `
    body::after, body::before, html::after, html::before {
      display: none !important;
      content: none !important;
      box-shadow: none !important;
    }
    .gradient-background::after, .gradient-background::before {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
}

// Export for global access
window.ThemeManager = ThemeManager;











